import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import { Country } from "../../components/LanguageButton/LanguageButton";
import StartScreen, { Screen } from "../../pages/StartScreen/StartScreen";

export interface StartScreenJavaState {
    readonly accountRoute?: Screen;
    readonly bettingAllowed: boolean;
    readonly buttonsBlockedForDispatchTerminal?: boolean;
    readonly customerCardEnabled: boolean;
    readonly lwkButtonEnabled: boolean;
    readonly manualTicketCheckAllowed: boolean;
    readonly semiSelfService: boolean;
    readonly showForeignShopInfo: boolean;
    readonly supportedLanguages: Country[];
    readonly recommendationsEnabled: boolean;
    readonly resultsEnabled: boolean;
    readonly topCombisEnabled: boolean;
}
export const START_SCREEN_STATE_SCREEN = "StartScreenState";
export const NAVIGATION_ACTIONS = "Navigation";
export const LEGACY_NAVIGATION_ACTIONS = "StartScreenNavigation";
export const START_SCREEN_LANGUAGE_ACTIONS = "StartScreenLanguageChangeActions";

const INITIAL_STATE: StartScreenJavaState = {
    bettingAllowed: false,
    buttonsBlockedForDispatchTerminal: false,
    customerCardEnabled: false,
    lwkButtonEnabled: true,
    manualTicketCheckAllowed: false,
    recommendationsEnabled: false,
    topCombisEnabled: false,
    resultsEnabled: true,
    semiSelfService: true,
    showForeignShopInfo: false,
    supportedLanguages: []
};

const actionsCreators: ActionsCreators<{
    changeLanguage: (lang: Country) => Country;
}> = {
    changeLanguage: {
        creator: (lang: Country) => lang,
        name: START_SCREEN_LANGUAGE_ACTIONS
    }
};

export default connectToJava({
    actionsCreators,
    state: {
        [START_SCREEN_STATE_SCREEN]: INITIAL_STATE
    },
    stateMapper: ({ StartScreenState: { supportedLanguages, ...state } }) => ({
        ...state,
        languages: supportedLanguages
    })
})(StartScreen);
